import LogInCtaButton from 'components/shared/LogInCtaButton/LogInCtaButton'
import PropTypes from 'prop-types'
import React from 'react'
import { withNamespaces } from 'react-i18next'

import './Account.scss'

export const Account = ({ t }) => {
  return (
    <div className="c-account">
      <div className="sc-pr-account rpf-shadow-centre">
        <h4 className="c-account__title">{t('pathway.account')}</h4>
        <div className="c-account__badges" />
        <div className="c-account__cta">
          <LogInCtaButton className="c-account__button" />
        </div>
        <div className="c-account__badges c-account__badges_reversed" />
      </div>
    </div>
  )
}

Account.propTypes = {
  t: PropTypes.func.isRequired,
}

export default withNamespaces('translations')(Account)
